import React, { useContext } from 'react';
import { Box, Pagination, useMediaQuery, Theme } from '@mui/material';
// contexts
import { CardFilterContext } from 'contexts/cardFilter';

type Props = {
  count: number,
};

const PageBox: React.FC<Props> = ({ count }) => {
  const { cardFilter, setCardFilter, loadCards } = useContext(CardFilterContext);
  const numPages = Math.ceil(count / cardFilter.pageSize);

  const handleChangePage = (e: React.ChangeEvent<unknown>, page: number) => {
    if (cardFilter.page === page) {
      return;
    }
    const newCardFilter = { ...cardFilter, page: page };
    setCardFilter(newCardFilter);
    loadCards(newCardFilter);
    console.log(newCardFilter);
  };

  const isMobileSize = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  return (
    <Box>
      <Pagination
        count={numPages}
        onChange={handleChangePage}
        page={cardFilter.page}
        size={isMobileSize ? 'small' : 'medium'}
      />
    </Box>
  );
};

export default PageBox;
